import { render, staticRenderFns } from "./FollowOrder.vue?vue&type=template&id=93d5c4ca&"
import script from "./FollowOrder.vue?vue&type=script&lang=js&"
export * from "./FollowOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports